import { action } from 'mobx';
import config from 'config';
import HttpClient from 'utils/httpclient';
import BaseStore from 'stores/BaseStore';

class PageStore extends BaseStore {
  constructor () {
    super('pages', 'page', { site_model: true });
  }

  @action getFields () {
    return HttpClient.get(`${config.api}/site/${this.getCurrentSiteID()}/getFields`)
      .then(action(response => {
        return response.data;
      }));
  }
  @action getPathList (pageId) {
    return HttpClient.get(`${config.api}/site/${this.getCurrentSiteID()}/page/${pageId}/paths`)
      .then(action(response => {
        return response.data;
      }));
  }

  @action getVersions (pageId) {
    return HttpClient.get(`${config.api}/page/${pageId}/versions`)
      .then(action(response => {
        return response.data;
      }));
  }
}

export default new PageStore();
